<template lang="pug">
  v-container.pa-0(style="max-width: 800px;")
    v-card(tile v-if="lead" :style="isPrinting? 'min-height: 96vh; border-radius: 0' : 'min-height: 96vh;'" :class="isPrinting? 'elevation-0': ''")
      v-card-title.px-3.white
        p.mb-0.h6.basic800--text {{ invoiceName }} &#35;{{ lead.rid }}
        v-spacer
        v-chip.text-uppercase.my-auto.button-AA-tiny(small outlined label :color="lead.status | leadStatusColor" :style="{ 'background-color': chipBackgroundColor(lead.status) + '!important' }" )
          | {{ lead.status | leadStatusDisplay }}

      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      v-card-text.pa-4.text-center(v-else)
        v-form(ref="form")
          div
            v-icon(v-if="$route.query.error && !lead.paid" color="red" :size="30" x-large) mdi-close-circle
            eva-icon(v-else name="checkmark-circle-2-outline" :fill="lead.paid ? $vuetify.theme.themes[$theme].success500 : $vuetify.theme.themes[$theme].basic600T48" height="60" width="60")
            p.s1.mb-0.mt-5(:class="lead.paid ? 'primary500--text' : 'danger500--text'") {{ lead.paid ? 'Amount paid' : 'Balance due' }}
            template(v-if="lead.paid")
              div.h4.primary500--text.text-center {{ totalPaid | displayPrice($currency) }}
              div.s1.primary400--text.mt-1 {{ lead.record_date | convertServerDateWithZone('Asia/Kuala_Lumpur') }}

            template(v-else)
              div.h4.primary500--text.text-center {{ amountDue | displayPrice($currency) }}
              div(v-if="$route.query.error")
                div.p2.danger500--text.mt-2 Payment failed
                v-chip.mt-2(color="textColorAccent" small label link @click="verifyPayment()" dark) Verify again
                  v-icon(right size=14) mdi-refresh
              div.p2.primary400--text.mt-2(v-else) Please check all details before proceeding to payment

          v-divider.basic300.my-6
          .company-details.text-left.mt-4(v-if="company")
            div.d-flex
              div(style="word-break: break-word")
                div.s1.primary500--text {{ company.name }}
              v-spacer
              div
                v-chip.text-uppercase.my-auto.button-AA-tiny(v-if="!isPrinting" small outlined label color="success500" :style="{ 'background-color': $vuetify.theme.themes[$theme].successT08 + '!important'}" @click="clickAskMerchat()")
                  v-icon(left small) mdi-whatsapp
                  | WhatsApp us
            div.p2.primary500--text {{ company.phone }}
            div.p2.primary500--text(v-if="company.address")
              div {{ company.address.address_1 }},
              div {{ company.address.address_2 }}, {{ company.address.city }},
              div {{ company.address.postcode }}, {{ company.address.state }}, {{ company.address.country }}.
            
          .client-details.text-left.mt-8
            div.p1.primary500--text Bill to:
            div.s1.primary500--text {{ lead.name }}
            div.p2.primary500--text(v-if="lead.email") {{ lead.email }}
            div.p2.primary500--text {{ lead.phone | phoneFormat }}
            div.mt-5(v-if="lead.shipping_address && !lead.pickup")
              div.p1.primary500--text Shipping address:
              div.p2.primary500--text {{ lead.shipping_address.address_1 }},
              div.p2.primary500--text {{ lead.shipping_address.address_2 }}, {{ lead.shipping_address.city }},
              div.p2.primary500--text {{ lead.shipping_address.postcode }}, {{ lead.shipping_address.state }}, {{ lead.shipping_address.country }}.

          v-divider.my-4.basic300

          v-simple-table(dense)
            thead
              tr
                th.pa-0(style="border: none")
                  div.s1.primary400--text.text-start.mr-1 Description
                th.pa-0(style="border: none")
                  div.s1.primary400--text.text-end.mx-1 Price
                th.pa-0(style="border: none")
                  div.s1.primary400--text.text-end.ml-1 Amount
            tbody
              template(v-for="p in invoice.products")
                tr(:key="p.id")
                  td.text-start.pa-0(style="border: none; vertical-align:top;")
                    div.my-1
                      div.p2.primary500--text.mr-1 {{ p.quantity }} x {{ p.name }} {{ p.addons.length > 0 ? ' set' : '' }}
                      div.c1.danger500--text(v-if="p.product.inventory_enabled && p.product.inventory_qty < p.quantity && !lead.paid") {{ p.product.inventory_qty > 0 ? `Only ${p.product.inventory_qty} left in stock` : 'Sold out' }}
                      div.ml-3
                        template(v-if="p.addons.length > 0")
                          div.c1.primary300--text.mr-1 {{ p.name }}
                        template(v-for="a in p.addons")
                          div.c1.primary300--text.mr-1 + {{ a.name }}{{ a.quantity_per_set > 1 ? ' x ' + a.quantity_per_set : '' }}
                          div.c1.danger500--text(v-if="a.inventory_enabled && a.inventory_qty < a.quantity && !lead.paid") {{ a.inventory_qty > 0 ? `Only ${a.inventory_qty} left in stock` : 'Sold out' }}
                        template(v-if="p.description_visibility.includes('invoice')")
                          .c1.primary300--text.mr-1 {{ p.description }}
                  td.text-end.pa-0(style="border: none; min-width: 70px; vertical-align:top;")
                    div.my-1
                      div.p2.primary500--text.mx-1 {{ p.price_per_set | displayPrice($currency) }}
                      div.mt-3(v-if="p.product.inventory_enabled && p.product.inventory_qty < p.quantity && !lead.paid")
                      template(v-if="p.addons.length > 0")
                        div.c1.primary300--text.mx-1 {{ p.price | displayPrice($currency) }}
                      template(v-for="a in p.addons")
                        div.c1.primary300--text.mx-1 {{ a.price * a.quantity_per_set | displayPrice($currency) }}
                  td.text-end.pa-0(style="border: none; min-width: 70px; vertical-align:top;")
                    div.my-1.p2.primary500--text.ml-1 {{ p.price_per_set * p.quantity | displayPrice($currency) }}

          div.my-5.dotted
          
          div
            div.d-flex.mt-1(v-if="discountPrice")
              div.p1.primary400--text {{ invoiceDiscountPrice? 'Total Product Discount:' : 'Discount' }}
              v-spacer
              div.p1.primary400--text - {{ discountPrice | displayPrice($currency) }}
            div.d-flex.mt-1
              div.p1.primary400--text Subtotal:
              v-spacer
              div.p1.primary400--text {{ subtotalPrice | displayPrice($currency) }}
            div.d-flex.mt-1
              div.p1.primary400--text Tax:
              v-spacer
              div.p1.primary400--text {{ taxAmount }}%
            div.d-flex.mt-1(v-if="invoiceDiscountPrice")
                div.p1.primary400--text Discount:
                v-spacer
                div.p1.primary400--text - {{ invoiceDiscountPrice | displayPrice($currency) }}
            div.d-flex.align-center.mt-1(v-if="shippingFee !== null && !lead.pickup")
              div.p1.primary400--text Delivery Charge:
              v-spacer
              div.p1.primary400--text(v-if="shippingFee === 0")
                v-chip.px-1(color="success500" small label outlined)
                  v-icon(small).pr-1 mdi-truck-fast
                  | Free Shipping
              div.p1.primary400--text(v-else) {{ shippingFee | displayPrice($currency) }}
            div.d-flex.mt-1
              div.h6.primary--text Total:
              v-spacer
              div.h6.primary--text {{ totalPrice | displayPrice($currency) }}
            div.d-flex.mt-1(v-if="promoDiscountPrice")
              div.p1.primary400--text Promo Discount:
              v-spacer
              div.p1.primary400--text {{ promoDiscountPrice | displayPrice($currency) }}
            div.d-flex.mt-1
              div.p1.primary400--text Amount Paid:
              v-spacer
              div.p1.primary400--text {{ totalPaid | displayPrice($currency) }}

            .installment(v-if="lead.installment && !lead.paid")
              div.d-flex.py-2.ml-n2.mr-n2.mt-1(:style="`background-color: ${$vuetify.theme.themes[$theme].dangerT16}; border-radius: 4px`")
                div.s1.primary--text.ml-2 Balance Due:
                v-spacer
                div.s1.primary--text.mr-2 {{ amountDue | displayPrice($currency) }}
              div.d-flex.mt-2(v-if="income.due_date || income.quotation_due_date")
                div.c1.primary400--text
                  span(v-if="income.quotation && income.quotation_due_date") This quotation expires on: {{ income.quotation_due_date | humanizeDate }}
                  span(v-else-if="income.due_date") Please complete payment before: {{ income.due_date | humanizeDate }}

          div.mt-12.text-left(v-if="income.notes")
              .p2.primary400--text Notes:
              .p2.primary400--text.mt-2 {{ income.notes }}
          
          div.mt-6
            div.f1.primary400--text {{ $t('powered_by_yezza') }}
            div.f2.primary400--text(v-if="lead.paid") This is a computer generated receipt. No signature required.
            div.f2.primary400--text(v-else) This is a computer generated invoice. No signature required.

          div.pt-6(v-if="!lead.paid && !lead.cod && !lead.pay_at_shop && !income.quotation")
            v-btn.button-AA-medium.white--text(v-if="hasPaymentMethod" color="textColorAccent" depressed block @click="clickPay" :disabled="outOfStock") Pay now
            div.caption.danger500--text.mt-2(v-if="outOfStock") Not enough stock available. Consult with seller.

    .modals
      apply-coupon-dialog(v-if="showApplyCouponDialog" :open.sync="showApplyCouponDialog" :invoice="invoice" @applied="getInvoice")
      AddCustomer(v-if="showAddCustomerDialog" :open.sync="showAddCustomerDialog" :parentCustomer="customer" @edited="updateCustomer" :company="company" :requiredContact="true")
      y-dialog(v-if="showSetAmountDialog" v-model='showSetAmountDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text Set Amount
          v-divider.basic300
          v-card-text.pa-4
            v-form(ref="form")
              p.mb-1.label.basic600--text.text-uppercase {{ $t('price.label') }}
              v-text-field.mt-2(v-model='paymentAmount' :placeholder="$t('price.placeholder')" background-color="basic200" height="40" outlined dense type="number" :rules="priceRules" :prefix="$currency.symbol")
            v-btn.button-AA-medium.white--text(block color='textColorAccent' depressed height=32 @click='clickPayPartialAmount()' :loading="isLoading")
              | Pay this amount
            div.text-center.mt-1.p2 or
            v-btn.button-Aa-medium(block color='textColorAccent' depressed height=32 @click='clickPayFullAmount()' :loading="isLoading" text)
              div(v-if="lead.status == 'partial_payment'") Pay remaining amount
              div(v-else) Pay full amount

</template>

<script>
import { mapActions } from 'vuex'
import ParcelHistoryDialog from '@/views/invoice/components/ParcelHistoryDialog'
import ApplyCouponDialog from '@/views/invoice/components/ApplyCouponDialog'
import LinkifyText from '@/components/LinkifyText.vue'
import AddCustomer from '@/components/yezzabook/dialogs/income/addincome/AddCustomer.vue'

export default {
  name: 'CustomerInvoice',
  components: { ParcelHistoryDialog, ApplyCouponDialog, LinkifyText, AddCustomer },
  props: ['lead'],
  data: () => ({
    isFetching: true,
    income: null,
    invoice: null,
    company: null,
    bankList: [],
    customer: null,
    showSetAmountDialog: false,
    showApplyCouponDialog: false,
    showAddCustomerDialog: false,
    paymentAmount: null,
    isLoading: false,
    rules: {
      not_empty: [
        val => val != null || 'This field is required',
        val => val > 0 || 'This field is required'
      ]
    }
  }),
  computed: {
    invoiceName () {
      if (!this.income) {
        return ''
      }
      if (this.invoice && this.invoice.paid) {
        return 'Receipt'
      }
      return this.income.quotation ? 'Quotation' : 'Invoice'
    },
    isPrinting () {
      if (this.$route.path.includes('print-invoices')) {
        return true
      }
      return false
    },
    isEditable () {
      if (this.lead.paid) {
        return false
      }
      if (this.lead.cod) {
        return false
      }
      if (this.lead.pay_at_shop) {
        return false
      }
      if (this.lead.installment && this.lead.status == 'partial_payment') {
        return false
      }
      return true
    },
    priceRules () {
      return [
        v => !!v || 'Amount is required',
        v => v != 0|| 'Amount is required',
        v => v >= this.minPaymentAmount/this.$currency.multiplier || `Amount should not be below ${this.$currency.symbol} ${(parseFloat(this.minPaymentAmount/this.$currency.multiplier)).toFixed(this.$currency.exponent)}`,
        v => v <= this.amountDue/this.$currency.multiplier || `Amount should not be above ${this.$currency.symbol} ${(parseFloat(this.amountDue/this.$currency.multiplier)).toFixed(this.$currency.exponent)}`,
      ]
    },
    outOfStock() {
      if (!this.invoice) return false
      for (let i = 0; i < this.invoice.products.length; i++) {
        let p = this.invoice.products[i]
        if (p.product.inventory_enabled && p.product.inventory_qty < p.quantity) {
          return true
        }
      }
      return false
    },
    shippingFee() {
      if (!this.invoice) return 0
      return this.invoice.shipping_fee
    },
    discountPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_discount
    },
    invoiceDiscountPrice() {
      if (!this.invoice) return 0
      return this.invoice.invoice_discount
    },
    promoDiscountPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_promo_discount
    },
    subtotalPrice() {
      if (!this.invoice) return 0
      return this.invoice.subtotal_amount
    },
    totalPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_amount
    },
    totalPaid() {
      if (!this.invoice) return 0
      return this.invoice.total_paid
    },
    amountDue() {
      if (!this.invoice) return 0
      return this.invoice.total_amount - this.invoice.total_paid
    },
    taxAmount() {
      if (!this.invoice) return 0
      return this.invoice.company.tax_rate
    },
    minPaymentAmount() {
      if (!this.invoice.minimum_payment) return 0
      if (this.invoice.minimum_payment > this.amountDue) {
        return this.amountDue
      }
      return this.invoice.minimum_payment
    },
    hasPaymentMethod () {
      if (this.company && this.company.default_payment_gateway) return true
      if (this.bankList.length > 0) return true
      if (this.lead.allow_cod) {
        return true
      }
      if (this.lead.allow_pay_at_shop) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.fetchRequiredInfo()
    if (!this.lead.paid) {
      this.fetchBankAccount()
    }
    this.company = this.lead.form.company
    this.customer = {
      name: this.lead.name,
      email: this.lead.email,
      phone: this.lead.phone,
      address: this.lead.address,
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getInvoice () {
      this.isFetching = true
      this.$axios.get(`/invoices/${this.lead.pid}/`)
        .then((response) => {
          this.isFetching = false
          this.invoice = response.data
        })
        .catch(() => {})
    },
    fetchBankAccount () {
      this.$axios.get(`/leads/${this.lead.pid}/directpay/`)
        .then((response) => {
          response.data.results.forEach(bank => {
            if (bank.enabled) {
              this.bankList.push(bank)
            }
          })
        })
        .catch(() => {})
    },
    fetchRequiredInfo () {
      this.isFetching = true
      this.income = { ...this.lead.income }
      this.getInvoice()
    },
    updateCustomer (val) {
      this.axios.patch(`/leads/${this.lead.pid}/`, val)
        .then(resp => {
          this.lead = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    clickPay() {
      if (!this.lead.phone && !this.lead.email) {
        this.showMessage(['error', this.$t('error_message.please_fill_email_phone')])
        this.showAddCustomerDialog = true
        return
      }
      if (this.lead.installment) {
        this.showSetAmountDialog = true
      } else {
        location.href = `/invoices/${this.lead.pid}/pay`
      }
    },
    clickPayPartialAmount() {
      if (!this.$refs.form.validate()) {
        return
      }
      const amountInCent = (parseFloat(this.paymentAmount)).toFixed(this.$currency.exponent).replace('.', '')
      location.href = `/invoices/${this.lead.pid}/pay?amount=${amountInCent}`
    },
    clickPayFullAmount() {
      location.href = `/invoices/${this.lead.pid}/pay`
    },
    openDeliveryOption (){
      location.href = `/invoices/${this.lead.pid}/delivery`
    },
    openAddProducts () {
      location.href = `/invoices/${this.lead.pid}/catalogs`
    },
    startCopyOrder () {
      if (this.lead.member && this.lead.member.role === 'Agent') {
        this.$axios.get(`/forms/${this.lead.form.slug}?agent_member_id=${this.lead.member.id}`)
        .then((response) => {
          location.href = `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${response.data.slug}/?customer=${this.lead.pid}`
        })
        .catch(() => {})
        return
      }
      if (this.lead.form.type === 'store') {
        location.href = `https://${this.lead.form.company.slug}.${process.env.VUE_APP_STORE_URL_DOMAIN}/?customer=${this.lead.pid}`
        return
      }
      location.href = `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.lead.form.slug}/?customer=${this.lead.pid}`
    },
    verifyPayment() {
      location.href = `/invoices/${this.lead.pid}/verify`
    },
    clickAskMerchat () {
      window.open(`https://api.whatsapp.com/send?phone=${this.lead.member.phone}`, '_blank')
    },
    chipBackgroundColor (status) {
      if (status === 'new') {
        return this.$vuetify.theme.themes[this.$theme].infoT08
      } else if (status === 'follow_up') {
        return this.$vuetify.theme.themes[this.$theme].warningT08
      } else if (status === 'partial_payment') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      } else if (status === 'reject') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === 'processed') {
        return this.$vuetify.theme.themes[this.$theme].successT08
      } else if (status === 'shipped') {
        return this.$vuetify.theme.themes[this.$theme].warningT08
      } else if (status === 'received') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      } else if (status === 'cancelled') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === 'error') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === '') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      }
      return this.$vuetify.theme.themes[this.$theme].basic600T08
    }
  }
}
</script>

<style scoped>
.dotted {
  border-top: 2px dashed var(--v-primary400);
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
  {
    "en": {
      "price": {
        "label": "Amount",
        "placeholder": "0"
      }
    }
  }
</i18n>
